import React, { useContext, useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import { useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faBook,
	faBoxOpen,
	faChartPie,
	faCog,
	faFileAlt,
	faHandHoldingUsd,
	faSignOutAlt,
	faTable,
	faTimes,
	faCalendarAlt,
	faMapPin,
	faInbox,
	faRocket,
	faUser,
	faUsers,
	faHotel,
	faRegistered,
	faBlog,
	faHistory,
	faPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
	Nav,
	Badge,
	Image,
	Button,
	Dropdown,
	Accordion,
	Navbar,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import routes, { routesPath } from "src/app/routes";
import { AuthContext } from "src/app/contexts/AuthContext";
import { AUTH_REDUCER_REMOVE_AUTH_DATA, NAV_REDUCER_GET_NAV_DATA } from "src/app/common/constants";
import { faAdversal, faReact } from "@fortawesome/free-brands-svg-icons";
import { NavContext } from "../contexts/NavContext";

export default (props = {}) => {
	const location = useLocation();
	const { pathname } = location;
	const [show, setShow] = useState(false);
	const showClass = show ? "show" : "";

	const onCollapse = () => setShow(!show);

	const NavItem = (props) => {
		const {
			title,
			link,
			external,
			target,
			icon,
			image,
			badgeText,
			badgeBg = "secondary",
			badgeColor = "primary",
		} = props;
		const classNames = badgeText
			? "d-flex justify-content-start align-items-center justify-content-between"
			: "";
		const navItemClassName = link === pathname ? "active" : "";
		const linkProps = external ? { href: link } : { as: Link, to: link };

		return (
			<Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
				<Nav.Link {...linkProps} target={target} className={classNames}>
					<span>
						{icon ? (
							<span className="sidebar-icon">
								<FontAwesomeIcon icon={icon} />{" "}
							</span>
						) : null}
						{image ? (
							<Image
								src={image}
								width={20}
								height={20}
								className="sidebar-icon svg-icon"
							/>
						) : null}

						<span className="sidebar-text">{title}</span>
					</span>
					{badgeText ? (
						<Badge
							pill
							bg={badgeBg}
							text={badgeColor}
							className="badge-md notification-count ms-2"
						>
							{badgeText}
						</Badge>
					) : null}
				</Nav.Link>
			</Nav.Item>
		);
	};

	//AuthContext
	const { authData, dispatch } = useContext(AuthContext);
	const handleLogOut = () => {
		dispatch({ type: AUTH_REDUCER_REMOVE_AUTH_DATA });
	};

	//NavContext
	const { navData, dispatch: getNavData } = useContext(NavContext);
	useEffect(() => {
		console.log("auth data changed!!");
		getNavData({ type: NAV_REDUCER_GET_NAV_DATA, payload: authData?.user_data });
	}, [authData]);

	return (
		<>
			<Navbar
				expand={false}
				collapseOnSelect
				variant="dark"
				className="navbar-theme-primary px-4 d-md-none"
			>
				<Navbar.Brand className="me-lg-5" as={Link} to={routesPath.DashboardOverview.path}>
					<i class={faReact} className="navbar-brand-light"></i>
				</Navbar.Brand>
				<Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
					<span className="navbar-toggler-icon" />
				</Navbar.Toggle>
			</Navbar>
			<CSSTransition timeout={300} in={show} classNames="sidebar-transition">
				<SimpleBar
					className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}
				>
					<div className="sidebar-inner px-4 pt-3">
						<div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
							<div className="d-flex align-items-center">
								<div className="user-avatar lg-avatar me-4">
									<FontAwesomeIcon
										icon={faUser}
										style={{ fontSize: "30px", color: "orange" }}
										className="user-avatar md-avatar card-img-top rounded-circle border-white"
									/>
								</div>
								<div className="d-block">
									<h6>Hi, {authData?.user_data?.name}</h6>
									<Button
										as={Link}
										variant="secondary"
										size="xs"
										to={routesPath.SignIn.path}
										className="text-dark"
										onClick={() => handleLogOut()}
									>
										<FontAwesomeIcon icon={faSignOutAlt} className="me-2" />{" "}
										Sign Out
									</Button>
								</div>
							</div>
							<Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
								<FontAwesomeIcon icon={faTimes} />
							</Nav.Link>
						</div>
						<Nav className="flex-column pt-3 pt-md-0">
							<NavItem
								title={
									<center>
										<b>JoRooms Dashboard</b>
									</center>
								}
								link="#"
								style={{ display: "inline-block" }}
							/>
							<NavItem
								title="Overview"
								link={routesPath.DashboardOverview.path}
								icon={faChartPie}
							/>

							{navData &&
								navData.map((nav) =>
									nav?.label === "Blogs" ? (
										<NavItem
											external
											target="_blank"
											title={nav?.label}
											link={nav?.link}
											icon={nav?.icon}
										/>
									) : (
										<NavItem
											title={nav?.label}
											link={routesPath?.[nav?.link].path}
											icon={nav?.icon}
										/>
									)
								)}
						</Nav>
					</div>
				</SimpleBar>
			</CSSTransition>
		</>
	);
};
